"use client";

import { useVisitorAge } from "@/hooks/use-visitor-age";
import { useRouter } from "next/navigation";
import { type ReactNode, useEffect } from "react";

/**
 * Client gate for /contact: known kids are sent home.
 * Complements the middleware cookie check for localStorage-only / first-paint cases.
 */
export function ContactAccessGate({ children }: { children: ReactNode }) {
  const { isKnownChild } = useVisitorAge();
  const router = useRouter();

  useEffect(() => {
    if (isKnownChild) {
      console.info("[contact-access] Redirecting known kid away from /contact");
      router.replace("/");
    }
  }, [isKnownChild, router]);

  if (isKnownChild) {
    return null;
  }

  return <>{children}</>;
}
